// extracted by mini-css-extract-plugin
export default {"modal":"NewOpportunityChooserModal_modal__rZ2zr","subtitle":"NewOpportunityChooserModal_subtitle__HikYG","cards":"NewOpportunityChooserModal_cards__58YNV"};